import { ComponentValue } from '../sceneDataSchema';

export function numberConverter(value: ComponentValue) {
  if (typeof value === 'string' && value !== '') {
    if (!isNaN(+value)) {
      return +value;
    }
  }

  return value;
}
